module.exports = __webpack_public_path__ + "gf.svg?d465c82c6c1218f4dbd6889e058fff52";